import { RESEND_BASE_URL } from '../config/api';

// Define endpoints for ResendController
const RESEND_ENDPOINTS = {
    RESEND_EVENT: (eventId: number) => `/events/${eventId}`,
    RESEND_MARKETS: (eventId: number) => `/events/${eventId}/markets`,
    RESEND_RESULTS: (eventId: number) => `/events/${eventId}/markets-results`,
    RESEND_SCORES: (eventId: number) => `/events/${eventId}/scores`
};

class ResendService {
    async resendEvent(eventId: number): Promise<void> {
        const response = await fetch(`${RESEND_BASE_URL}${RESEND_ENDPOINTS.RESEND_EVENT(eventId)}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Failed to resend event: ${response.statusText}`);
        }
    }

    async resendMarkets(eventId: number): Promise<void> {
        const response = await fetch(`${RESEND_BASE_URL}${RESEND_ENDPOINTS.RESEND_MARKETS(eventId)}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Failed to resend markets: ${response.statusText}`);
        }
    }

    async resendResults(eventId: number): Promise<void> {
        const response = await fetch(`${RESEND_BASE_URL}${RESEND_ENDPOINTS.RESEND_RESULTS(eventId)}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Failed to resend results: ${response.statusText}`);
        }
    }

    async resendScores(eventId: number): Promise<void> {
        const response = await fetch(`${RESEND_BASE_URL}${RESEND_ENDPOINTS.RESEND_SCORES(eventId)}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`Failed to resend scores: ${response.statusText}`);
        }
    }
}

export const resendService = new ResendService();
